import { render, staticRenderFns } from "./catalog-brand-page.vue?vue&type=template&id=58796f6e&"
import script from "./catalog-brand-page.vue?vue&type=script&lang=ts&"
export * from "./catalog-brand-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports